module.exports = __webpack_public_path__ + "static/media/tuihuodan642.67bacf9e.png";